/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AnalyticsSignalSensor = {
  enabled: boolean;
  id: string;
  mode: string;
  name: string;
  signalIds: Array<string>;
};

/** @internal */
export const AnalyticsSignalSensor$inboundSchema: z.ZodMiniType<
  AnalyticsSignalSensor,
  unknown
> = z.pipe(
  z.object({
    enabled: z.boolean(),
    id: z.string(),
    mode: z.string(),
    name: z.string(),
    signal_ids: z.array(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "signal_ids": "signalIds",
    });
  }),
);

export function analyticsSignalSensorFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsSignalSensor, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsSignalSensor$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsSignalSensor' from JSON`,
  );
}
